import { createReducer } from "../../core/core-redux/reducer/createReducer";
import { CHANGES_LOADED } from "./changesLoad/changesLoaded.action";
import { changesLoadedPartialReducer } from "./changesLoad/changesLoaded.reducer";
import { CHANGES_LOADING } from "./changesLoad/changesLoading.action";
import { changesLoadingPartialReducer } from "./changesLoad/changesLoading.reducer";
import { RELOAD_CHANGES } from "./changeReload";
import { ChangesType } from "../types";
import { SET_CHANGES_GENERATED, UPDATE_CONTEXT, VIEW_TYPE_CHANGED, workspaceChangesReducer } from "./changeWorkspace";
import { changeTypeColoringReducer, SAVE_CHANGE_TYPE_COLORING } from "./changeTypeColoring";
import { CHANGE_TYPE_CHANGED, SET_CHANGE_TYPES, updateChangeTypeReducer } from "./changeType";
import { CONTEXT_WORKSPACE } from "../changesConstants";

export const changesReducer = createReducer<ChangesType>(
    {
        changesLoad: {
            loading: false,
        },
        changeType: {
            changeType: [],
        },
        changeTypeColoring: {
            changeToColorMapping: {
                N: "",
                W: "",
                U: "",
                O: "",
                I: "",
            },
        },
        workspaceChanges: {
            context: CONTEXT_WORKSPACE,
            view: "",
            dateOfGeneration: "Not defined",
        },
    },
    {
        [CHANGE_TYPE_CHANGED]: updateChangeTypeReducer,
        [SET_CHANGE_TYPES]: updateChangeTypeReducer,
        [SAVE_CHANGE_TYPE_COLORING]: changeTypeColoringReducer,
        [SET_CHANGES_GENERATED]: workspaceChangesReducer,
        [VIEW_TYPE_CHANGED]: workspaceChangesReducer,
        [UPDATE_CONTEXT]: workspaceChangesReducer,
        [CHANGES_LOADING]: changesLoadingPartialReducer,
        [RELOAD_CHANGES]: changesLoadingPartialReducer,
        [CHANGES_LOADED]: changesLoadedPartialReducer,
    }
);
